import { TimeScheduleNotificationType } from "services";

export const getTimeScheduleNotificationTypeLabel = (
  type: TimeScheduleNotificationType
) => {
  switch (type) {
    case TimeScheduleNotificationType.Email: {
      return "Email";
    }
    case TimeScheduleNotificationType.SMS: {
      return "SMS";
    }
    case TimeScheduleNotificationType.EmailAndSMS: {
      return "Email & SMS";
    }
    default:
      return null;
  }
};
